import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { PromiseState } from 'react-refetch';
import contactUsFormConnect from './connect';
import { setExtraFormData, isValidEmail } from './utils';
import { PromiseStateContainer } from '../../components';
import styles from './styles';

const GDPR_STATE = ['Unknown', 'Yes', 'No'];

function getNewConsentValue(value = '') {
  switch (value) {
    case 'true':
      return GDPR_STATE[1];
    case 'false':
      return GDPR_STATE[2];
    default:
      return GDPR_STATE[0];
  }
}

class ContactUsForm extends Component {
  state = {
    name: '',
    company: '',
    email: '',
    role: 'Software Developer',
    message: '',
    consent: undefined
  };

  componentDidMount() {
    /* eslint-env browser */
    this.metricsLib = window.metricsLib;
  }

  componentWillReceiveProps(nextProps) {
    const { postExtraDataResponse } = nextProps;
    this.onPostExtraData(postExtraDataResponse);
  }

  onPostExtraData(response) {
    if (response) {
      const { name, company, email, role, message } = this.state;
      const { source, subject, extraDataForPosting } = this.props;

      const metricsData = {
        email,
        name,
        company,
        role,
        message,
        source,
        subject,
        trackData: email,
        formId: extraDataForPosting.formId,
        lpId: extraDataForPosting.lpId
      };
      if (response.rejected) {
        this.metricsLib.track(extraDataForPosting.trackEventFail, metricsData);
      }
      if (response.fulfilled) {
        this.metricsLib.track(extraDataForPosting.trackEventRegister, metricsData);
      }
    }
  }

  handleInputChange = event => {
    const name = event.target.name;
    const value = event.target.value;
    this.setState({
      [name]: value
    });
  };

  submitHandler = (event, { isGDPR }) => {
    event.preventDefault();
    const { name, company, email, role, message } = this.state;
    const { postContactForm, postExtraData, extraDataForPosting, source, subject } = this.props;

    const formData = {
      email,
      name,
      company,
      role,
      message,
      source,
      subject
    };

    if (!isValidEmail(email)) return alert('Please enter a valid email');

    formData.showConsent = isGDPR;

    if (formData.showConsent) {
      formData.newConsent = getNewConsentValue(this.state.consent.toString());
    } else {
      formData.newConsent = getNewConsentValue();
    }

    postContactForm(formData);

    if (extraDataForPosting.url) {
      const extraData = setExtraFormData(this.state);
      postExtraData(extraData);
    }
  };

  handleConsent = event => {
    this.setState({ consent: Boolean(event.target.value) });
  };

  render() {
    const { name, company, email, role, message } = this.state;
    const { postContactFormResponse, isGdprFetch } = this.props;
    return (
      <PromiseStateContainer
        ps={PromiseState.race([isGdprFetch])}
        onRejection={() => <span />}
        onFulFillment={({ isGDPR }) => (
          <section className="contact-form-section">
            <div className="container">
              <form
                onSubmit={event => this.submitHandler(event, { isGDPR })}
                className="contact-form"
              >
                <h1 className="form-title">Contact Us</h1>
                <div className="col-xs-12 col-md-6">
                  <label htmlFor="name">
                    Name
                    <input
                      id="name"
                      type="text"
                      name="name"
                      onChange={this.handleInputChange}
                      value={name}
                      required
                    />
                  </label>
                </div>
                <div className="col-xs-12 col-md-6">
                  <label htmlFor="company">
                    Company
                    <input
                      id="company"
                      type="text"
                      name="company"
                      value={company}
                      onChange={this.handleInputChange}
                      required
                    />
                  </label>
                </div>
                <div className="col-xs-12 col-md-6">
                  <label htmlFor="email">
                    Email
                    <input
                      id="email"
                      type="email"
                      name="email"
                      value={email}
                      onChange={this.handleInputChange}
                      required
                    />
                  </label>
                </div>
                <div className="col-xs-12 col-md-6">
                  <label htmlFor="role">
                    Role
                    <select
                      id="role"
                      name="role"
                      required
                      onChange={this.handleInputChange}
                      value={role}
                    >
                      <option value="Software Developer">Software Developer</option>
                      <option value="Engineering Exec / Management">
                        Engineering Exec / Management
                      </option>
                      <option value="C-Level">C-Level</option>
                      <option value="IT operations">IT operations</option>
                      <option value="Product Management">Product Management</option>
                      <option value="Sales">Sales</option>
                      <option value="Marketing">Marketing</option>
                      <option value="Security & Compliance">Security & Compliance</option>
                      <option value="Other">Other</option>
                    </select>
                  </label>
                </div>
                <div className="col-xs-12">
                  <label htmlFor="message" className="textarea">
                    Message
                    <textarea
                      name="message"
                      id="message"
                      onChange={this.handleInputChange}
                      value={message}
                      required
                    />
                  </label>
                  {isGDPR && (
                    <div style={styles.gdpr.wrapper}>
                      <p>You hate junk? So do we.</p>
                      <p>
                        We&apos;d love it if you ticked the box below so we can continue sending
                        this kind of content your way. You can always change your mind and opt out
                        at any time. (And if you think what we’re sending IS junk, please let us
                        know so we can fix it.)
                      </p>
                      <div>
                        <label style={styles.gdpr.radioButtonWrapper} htmlFor="consent-accepted">
                          <input
                            style={styles.gdpr.radioButton}
                            id="consent-accepted"
                            type="radio"
                            value="1"
                            onChange={this.handleConsent}
                            checked={
                              typeof this.state.consent !== 'undefined' ? this.state.consent : false
                            }
                            required
                          />
                          <span>
                            Email me about product updates, learning resources, feedback surveys,
                            special offers and events.
                          </span>
                        </label>
                        <label style={styles.gdpr.radioButtonWrapper} htmlFor="consent-rejected">
                          <input
                            style={styles.gdpr.radioButton}
                            id="consent-rejected"
                            type="radio"
                            value=""
                            onChange={this.handleConsent}
                            checked={
                              typeof this.state.consent !== 'undefined'
                                ? !this.state.consent
                                : false
                            }
                            required
                          />
                          <span>No, please just send me this one resource.</span>
                        </label>
                      </div>
                    </div>
                  )}
                  {postContactFormResponse ? (
                    <PromiseStateContainer
                      ps={PromiseState.race([postContactFormResponse])}
                      onPending={() => (
                        <button className="btn btn-lg btn-success" type="submit" disabled>
                          Sending...
                        </button>
                      )}
                      onFulFillment={() => (
                        <button className="btn btn-lg btn-success success" type="submit" disabled>
                          Thanks for getting in touch!
                        </button>
                      )}
                    />
                  ) : (
                    <button className="btn btn-lg btn-success" type="submit">
                      send
                    </button>
                  )}
                </div>
              </form>
            </div>
          </section>
        )}
      />
    );
  }
}

ContactUsForm.propTypes = {
  source: PropTypes.string.isRequired,
  subject: PropTypes.string.isRequired,
  extraDataForPosting: PropTypes.shape({
    url: PropTypes.string,
    formId: PropTypes.string,
    lpId: PropTypes.string,
    trackEventRegister: PropTypes.string,
    trackEventFail: PropTypes.string
  }),
  postContactForm: PropTypes.func.isRequired,
  postExtraData: PropTypes.func.isRequired,
  postContactFormResponse: PropTypes.instanceOf(PromiseState),
  postExtraDataResponse: PropTypes.instanceOf(PromiseState),
  isGdprFetch: PropTypes.instanceOf(PromiseState).isRequired
};

ContactUsForm.defaultProps = {
  extraDataForPosting: {},
  postContactFormResponse: null,
  postExtraDataResponse: null
};

export default contactUsFormConnect(ContactUsForm);



// WEBPACK FOOTER //
// ./src/components/ContactUsForm/ContactUsForm.js